/* eslint-disable no-console */

const Logger = (channel?: string) => ({
    log: channel ? bindChannelTo(channel, console.log) : console.log,
    error: channel ? bindChannelTo(channel, console.error) : console.error,
    warn: channel ? bindChannelTo(channel, console.warn) : console.warn,
});

const bindChannelTo = (channel: string, loggingFunction: any) =>
    loggingFunction.bind(undefined, `%c[${channel}]`, 'font-weight: bold');

export default Logger;
